export default __webpack_public_path__ + "static/media/home.d8a881a8.jpg";